/** The MOVING banner while a block is picked up for a click-then-click move. */
import React from "react";

import { BoardBlock } from "../utils/derive";
import { fmtHours, lbb } from "../utils/tokens";

const MoveBanner: React.FC<{ block: BoardBlock; isLine: boolean; onCancel: () => void }> = ({
	block,
	isLine,
	onCancel,
}) => (
	<div
		style={{
			display: "flex",
			alignItems: "center",
			gap: 12,
			padding: "12px 24px",
			background: lbb.navy,
			color: lbb.paper,
			fontFamily: lbb.fontUi,
			fontSize: 14,
		}}
	>
		<span
			style={{
				fontFamily: lbb.fontMono,
				fontSize: 12,
				letterSpacing: "0.14em",
				color: lbb.brickSoft,
			}}
		>
			MOVING
		</span>
		<span>
			{block.workerName} · {block.label} · {fmtHours(block.duration)} ·{" "}
			{isLine ? "click a step phase to move it there" : "click a name to hand it to them"}
		</span>
		<button
			type="button"
			onClick={onCancel}
			style={{
				marginLeft: "auto",
				fontFamily: lbb.fontUi,
				fontSize: 13,
				color: lbb.navy20,
				background: "none",
				border: "none",
				cursor: "pointer",
				textDecoration: "underline",
			}}
		>
			cancel
		</button>
	</div>
);

export default MoveBanner;
